import { ApiClient } from './ApiClient';
export const CouponsApi = (instance, httpClient) => {
  const apiClient = new ApiClient(httpClient);
  async function getCoupons(Apis) {
    const url = Apis.coupons_url;
    const response = await apiClient.performAPIRequest({
      requestPromise: apiClient.post(url, instance),
      context: 'getCoupons',
      isArr: true
    });
    return response.totalResults ? response == null ? void 0 : response.coupons : [];
  }
  async function getCoupon(couponId, Apis) {
    var _response$coupon;
    const url = `${Apis.coupon_url}/${couponId}`;
    const response = await apiClient.performAPIRequest({
      requestPromise: apiClient.get(url, instance),
      context: 'getCoupon'
    });
    console.log('getCouponApi', {
      response,
      url
    });
    return response != null && (_response$coupon = response.coupon) != null && _response$coupon.id ? response.coupon : {};
  }
  return {
    getCoupon,
    getCoupons
  };
};
//# sourceMappingURL=couponsApi.js.map